var _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    stroke: "#3856a7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.16797 9.16699v12.22291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.2793 9.16699v12.22291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.2988 2.03711v4.07434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.14844 2.03711v4.07434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.05566 9.16699h18.33554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.3539 4.07422h-14.26096c-1.12516 0-2.03728.91206-2.03728 2.03715v13.24153c0 1.1251.91212 2.0371 2.03728 2.0371h14.26096c1.1252 0 2.0373-.912 2.0373-2.0371v-13.24153c0-1.12509-.9121-2.03715-2.0373-2.03715z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.05566 15.2786h18.33554"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/calendar.538430adf564dd8d543cc6cfb6cd0711.svg";